'use client'

import { Eye } from '@phosphor-icons/react'

import { shopTestId } from '@utils/utils-shop-test-ids'
import { useSearchParams } from 'next/navigation'

export type PreviewBadgeProps = {
  containerClassName?: string
}

export function PreviewBadge({ containerClassName }: PreviewBadgeProps) {
  const searchParams = useSearchParams()
  const previewToken = searchParams?.get('preview-token')

  if (!previewToken) return null

  return (
    <div className={containerClassName}>
      <div
        className="pointer-events-auto flex items-center space-x-4 rounded-xl bg-secondary-red px-6 py-3 font-body-small font-semibold text-white"
        data-testid={shopTestId('PreviewBadge.root')}
      >
        <Eye size={18} />
        <span>Du befindest dich in der Vorschau.</span>
      </div>
    </div>
  )
}
